export default __webpack_public_path__ + "static/media/nssc.f1cac0d5.PNG";